import React, {useEffect, useState,useRef} from "react";
import {useHistory} from "react-router";
import "./Transactions.scss";
import { Spin  } from 'antd';


import 'antd/dist/antd.css';
import {Collapse} from 'react-collapse'
import {getTransactionsApi} from "./TransactionsService";
import moment from "moment-jalaali";
import {useLocation} from "react-router-dom";
import {UserCouponDataPage} from "../StoreDetail/StoreDetailServices";

let notMore = false
let filtero = null

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

const ConvertToJalali = (date) =>{
    return  moment.utc(date.split('+')[0]).format('jYYYY/jMM/jDD');
}




function Transaction(){

    const history = useHistory()
    const location = useLocation()

    const [transactions,set_transactions] = useState([])
    const [credit,set_credit] = useState({})


    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        let cond = calc>3 || calc<-3
        // let cond = calc!==0

        if(!cond) {
            window.currentPage = window.currentPage +1
            if(!notMore)
                getTransactionsPage(convertFilter(filtero),window.currentPage)
        }

    }

    useEffect(()=>{
        //handle scroll arrived to Top
        notMore = false
        window.currentPage = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])

    useEffect(()=>{
        if(location && location.state && location.state.credit)
            set_credit(location.state.credit)
        getTransactions( {received:null,sent:null})
    },[])


    const getTransactions = async(obj) =>{
        set_loading(true)
        try{
            const res = await getTransactionsApi(obj,1)
            set_loading(false)
            set_transactions(res.data.results)
            console.log(res)
        }catch(e){
            set_loading(false)
            console.log(e)
        }
    }

    const getTransactionsPage = async (obj,page) => {

        try {
            const res = await getTransactionsApi(obj,page)
            set_loading(false)
            set_transactions((list)=>[...list,...res.data.results]);
        } catch (e) {
            set_loading(false)
            console.log(e.response.status)
            if(e.response.status===404){
                notMore = true
            }
        }
    }

    const [filter,set_filter] = useState(null)
    const [loading,set_loading] = useState(false)


    const convertFilter = (val)=>{
        switch(val){
            case 'in':
                return {received:true,sent:null}
                break;
            case 'out':
                return {received:null,sent:true}
                break;
            default:
                return {received:null,sent:null}
        }
    }

    const handleChangeFilter = async(val)=>{
        set_filter(val)
        filtero = val
        notMore = false
        window.currentPage = 1;
        getTransactions(convertFilter(val))
    }

    const TransactionsInputCard = ({item})=>{
        const [open,set_open] = useState(false)
        return(
            <div className="transactions-input-card" onClick={()=>{
                set_open(!open)
            }}>
                <div className="transactions-input-info">
                    <span className="point-text"> {item.campaign_points} امتیاز</span>
                    <span> تاریخ {ConvertToJalali(item.created)}<i className="fa fa-calendar"></i></span>
                </div>
                <Collapse isOpened={open}>
                    <div className="transactions-input-detail">
                        <span className="transactions-input-detail-title">{item.campaign.title}</span>
                        <img src={item.campaign.image} alt=""/>
                        {/*<p>*/}
                        {/*    جشنواره مرکز خرید سورنا بمدت یک ماه بروی روغن جایزه قررار داده است ,  بدین صورت که با خرید ۴ روغن ۳۰ امتیاز دریافت میکنید*/}
                        {/*</p>*/}
                    </div>
                </Collapse>
            </div>

        )
    }

    const TransactionsOutputCard = ({item})=>{
        const [open,set_open] = useState(false)

        return(
            <div className="transactions-output-card" onClick={()=>{
                set_open(!open)
            }}>
                <div className="transactions-input-info">
                    <span className="point-text"> {item.campaign_points*-1} امتیاز</span>
                    <span> تاریخ {ConvertToJalali(item.created)}<i className="fa fa-calendar"></i></span>
                </div>
                <Collapse isOpened={open}>
                    {item.service_info && item.service_info.award?<div className="transactions-output-detail">
                        <div className="transactions-input-detail-title">{item.service_info.award.title}</div>
                        <img src={item.service_info.award.image} alt=""/>
                        <p>
                            {item.service_info.award.description}
                        </p>
                    </div>:null}
                </Collapse>
            </div>
        )
    }

    return(
        <div className={"transactions-container"}>
            {/*Header*/}
            <div className="storeDetail-header" >
                <h5>تراکنش های کارت</h5>
                <i onClick={()=>{
                    history.goBack();
                }}
                   className="fa fa-arrow-left"></i>
            </div>

            <div className="transactions-filter">
                <select name="" id=""
                value={filter}
                onChange={e=>{
                    handleChangeFilter(e.target.value)
                }}
                >
                    <option value="all">همه</option>
                    <option value="out">خرج شده</option>
                    <option value="in">بدست آمده</option>
                </select>

                    <span>  موجودی : {credit.card_points?credit.card_points:0} امتیاز</span>
            </div>


            <div className="transactions-list" style={loading&&transactions.length<1?{marginTop:120}:{}}>
                <Spin spinning={loading}>
                {transactions.map(tr=>{
                    return (
                        <>
                            {tr.campaign_points>0?
                                <TransactionsInputCard  item={tr} />:
                                <TransactionsOutputCard item={tr}/>
                            }
                        </>
                    )
                })}
                </Spin>
            </div>
        </div>
    )


}
export default Transaction
